"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

// This style is used by other table's control cell too
var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;opacity:0;visibility:hidden;align-items:center;justify-content:flex-end;padding-right:", (0, _util.rem)(8), ";button{&.custom-icon{color:", theme.color.monochrome.mediumDark, ";}&:disabled{opacity:0.5;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=RowControls.styles.js.map